module.exports = '/ng-templates/use-cases/messages/kp-message-sending-internal/kp-message-sending-internal.tpl.ftl';
